import { useEffect, useState } from "react";

const particles = [
  { size: 60, x: "10%", y: "15%", delay: 0, duration: 6 },
  { size: 40, x: "80%", y: "20%", delay: 1, duration: 5 },
  { size: 80, x: "70%", y: "70%", delay: 0.5, duration: 7 },
  { size: 30, x: "20%", y: "75%", delay: 1.5, duration: 4 },
  { size: 50, x: "50%", y: "10%", delay: 0.8, duration: 6 },
  { size: 35, x: "85%", y: "50%", delay: 2, duration: 5 },
  { size: 45, x: "15%", y: "45%", delay: 0.3, duration: 7 },
];

export function SplashScreen({ onFinish }: { onFinish: () => void }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFadeOut(true), 4000);
    const end = setTimeout(onFinish, 4600);
    return () => {
      clearTimeout(timer);
      clearTimeout(end);
    };
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center hero-gradient overflow-hidden transition-opacity duration-500 ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* Floating geometric particles */}
      {particles.map((p, i) => (
        <div
          key={i}
          className="absolute rounded-lg border border-white/10 bg-white/5"
          style={{
            width: p.size,
            height: p.size,
            left: p.x,
            top: p.y,
            animation: `splash-float ${p.duration}s ease-in-out infinite, splash-rotate ${p.duration * 1.5}s linear infinite`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}

      {/* Radial glow behind logo */}
      <div className="absolute w-72 h-72 rounded-full bg-primary/20 blur-3xl animate-pulse" />

      {/* Logo DI */}
      <span className="relative z-10 text-8xl font-extrabold tracking-tight text-white animate-[splash-logo_0.8s_cubic-bezier(0.34,1.56,0.64,1)_forwards] opacity-0 drop-shadow-[0_0_30px_hsl(var(--primary)/0.5)]">
        DI
      </span>

      {/* Shimmer text */}
      <span className="relative z-10 mt-4 text-sm font-medium tracking-widest uppercase text-white/70 animate-[splash-shimmer_2s_ease-in-out_infinite] bg-gradient-to-r from-white/50 via-white to-white/50 bg-[length:200%_100%] bg-clip-text text-transparent">
        Tecnologia & Inovação
      </span>

      {/* Progress bar */}
      <div className="relative z-10 mt-8 h-1 w-32 overflow-hidden rounded-full bg-white/10">
        <div className="h-full tech-gradient animate-[splash-bar_2s_ease-in-out_forwards]" />
      </div>
    </div>
  );
}
